import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {catchError, map, Observable, of, tap, timeout} from 'rxjs';
import {ApiService} from '../../services/api/api.service';
import {SpinnerService} from '../../services/spinner/spinner.service';
import {StatItemDisplay, StatsDisplay, TopTenDataDTO} from 'src/app/model/types';
import {BreadcrumbsService} from '../../services/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.scss']
})
export class SearchPageComponent implements OnInit {

  statData$!: Observable<StatItemDisplay[]>;
  topTenData$!: Observable<TopTenDataDTO>;

  constructor(private router: Router, private api: ApiService, private spinner: SpinnerService,
              private breadcrumbsService: BreadcrumbsService) {
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.loadStatistic();
    this.breadcrumbsService.emptyBreadcrumbs()
  }

  search(queryEvent: { queryString: string, selectedFromAutocomplete: boolean }) {
    let queryParams: any = {query: queryEvent.queryString};

    if (queryEvent.selectedFromAutocomplete) {
      queryParams = {...queryParams, exact: true};
    }

    if (!queryEvent.selectedFromAutocomplete) {
      queryParams = {...queryParams, spellingCorrection: true};
    }

    this.router.navigate(['/risultati'], {queryParams: queryParams});
  }

  loadStatistic() {
    this.spinner.show();

    this.statData$ = this.api.statistics().pipe(
      tap(() => {
        this.spinner.hide();
      }),
      map((statItemObject: StatsDisplay) => Object.values(statItemObject)),
      timeout(5000),
      catchError(e => {
        this.spinner.hide();
        console.error('Timeout connessione backend');
        return of([]);
      }),
    );

    this.topTenData$ = this.api.topTenData().pipe(
      tap(() => {
        this.spinner.hide();
      }),
      timeout(5000),
      catchError(e => {
        this.spinner.hide();
        console.error('Timeout connessione backend');
        return of({medicinali: [], confezioni: []} as TopTenDataDTO);
      }),
    );
  }

}
